import { StoreInterface } from '../types';
import { PayloadAction } from '@reduxjs/toolkit';

const RootReducerMiddleware = (
  state: StoreInterface | undefined,
  actions: PayloadAction,
  next: (state: StoreInterface | undefined, actions: PayloadAction) => void,
) => {
  if (actions?.type === 'RESET_STORE') {
    state = undefined;
  }

  return next(state, actions);
};

export default RootReducerMiddleware;
